import React, { useState } from "react";
import { Button, Form, Modal, Row, Col } from "react-bootstrap";
import logo from "../../assets/virtue-logo-2.png";
import { Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "../../mixpanel";
import "react-phone-number-input/style.css";
import { useAppContext } from "../../AppContext";
import successIcon from "../../assets/successful-icon.svg";
import mixpanel from "mixpanel-browser";
import { validateEmail } from "../../utils/validation";
import {
  trackOmnisendVirtuePlusRegistrationFailure,
  trackOmnisendVirtuePlusRegistrationSuccess,
} from "../../omnisend";
import createAxios from "../../services/httpCommon";

const VirtuePlusModal = ({ showModal, closeModal }) => {
  const { showToast } = useAppContext();
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = {};
    if (!firstName) {
      validationErrors.firstName = "Please enter your First Name";
    }
    if (!email) {
      validationErrors.email = "Please enter your Email";
    }

    // if (!phoneNumber) {
    //   validationErrors.phoneNumber = "Please enter your Phone Number";
    // } else
    //   if (phoneNumber && !isNigerianPhoneNumber(phoneNumber)) {
    //   validationErrors.phoneNumber = "Please enter a valid Nigerian phone number";
    // }
    const emailError = validateEmail(email);
    if (emailError) {
      validationErrors.email = emailError;
    }

    setError(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setLoading(true);
      const body = {
        name: firstName,
        email: email,
      };

      try {
        const axiosInstance = await createAxios();
        const response = await axiosInstance.post(
          "/user/join-virtue-plus",
          body,
        );

        let isSuccess = false;
        if (typeof response.data === "string") {
          isSuccess = response.data.toLowerCase().includes("success");
        } else if (response.data && typeof response.data === "object") {
          isSuccess =
            response?.data?.message?.toLowerCase()?.trim() === "success";
        }

        if (isSuccess) {
          // Wrap tracking in try-catch to prevent UI blocking if a tracking tool fails
          try {
            const distinctId = localStorage.getItem(`production_unique_id`);

            if (distinctId) {
              mixpanel.identify(distinctId);
              mixpanel.people.set({
                $email: email,
                created_at: new Date().toISOString(),
              });
            }

            trackEvent("Virtue+ Member Registered", {
              name: firstName || "",
              email_address: email,
              attempted: new Date().toISOString(),
              device_type: navigator.userAgent,
            });

            trackOmnisendVirtuePlusRegistrationSuccess(email, firstName);
          } catch (trackingError) {
            console.warn("Tracking error (non-fatal):", trackingError);
          }

          setTimeout(() => {
            setLoading(false);
            setIsSubmitted(true);
          }, 1000);
        } else {
          console.warn("API returned non-success response:", response.data);
          setLoading(false);
          showToast({
            toastText:
              response?.data?.message || "An unexpected response was received",
            isSuccess: false,
          });
        }
      } catch (error) {
        console.error("Virtue+ Registration Error Trace:", error);
        setLoading(false);
        const errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          "An unexpected error occurred";

        showToast({
          toastText: errorMessage,
          isSuccess: false,
        });

        trackEvent("Failed Virtue+ Member Registration", {
          failure_reason: errorMessage,
          attempted_at: new Date().toISOString(),
          name: firstName || "",
          email_address: email,
        });
        trackOmnisendVirtuePlusRegistrationFailure(
          email,
          firstName,
          errorMessage,
        );
      }
    }
  };
  const openMailApp = () => {
    window.location.href = "mailto:";
  };

  return (
    <Modal show={showModal} onHide={closeModal} centered size="md">
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div
          style={{ backgroundColor: "white", fontFamily: "  Outfit" }}
          className=""
        >
          {" "}
          {loading ? (
            <div
              className="justify-content-center align-items-center text-center"
              style={{ padding: "80px" }}
            >
              <div className="spinner-border text-success" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : isSubmitted ? (
            <div className="login-form py-0 py-md-3 mb-3 px-0 px-md-2">
              <div className="text-center mb-3">
                <div>
                  <img
                    src={successIcon}
                    style={{ width: "50px", height: "50px" }}
                    alt="success icon"
                  />
                </div>
                <h2 className="mt-3 mb-4">
                  You’re officially a Virtue+ Member!
                </h2>
              </div>

              <div className="text-center">
                <h4
                  style={{ fontWeight: "500", color: "#5D5D5D" }}
                  className="px-0 px-md-4"
                >
                  Your exclusive promo code is waiting in your inbox. Sign in or
                  create an account to redeem it at checkout.
                </h4>
                <div className="d-flex gap-2">
                  <Button
                    onClick={() => {
                      openMailApp();
                      closeModal();
                    }}
                    className="btn-primary mt-5 w-100"
                    style={{ fontSize: "20px" }}
                  >
                    Check Your Inbox
                  </Button>
                  <Button
                    onClick={() => {
                      navigate("/signup");
                      trackEvent("Create an Account Click", {
                        clicked_at: new Date().toISOString(),
                        location_clicked: "V+ registration",
                        button_clicked: "Create an account",
                      });
                    }}
                    className="btn-outline-primary mt-5 w-100"
                    style={{ fontSize: "20px" }}
                  >
                    Create an Account
                  </Button>
                </div>
              </div>
            </div>
          ) : (
            <div className="login-form py-0 py-md-3 mb-md-5 px-0 px-md-4">
              <div className="text-center mb-3">
                <Image fluid src={logo} style={{ width: "90px" }} />
                <h2 className="mt-3 mb-3">Become a Virtue+ Member</h2>
                <h5
                  style={{
                    fontWeight: "500",
                    textAlign: "left",
                    fontSize: "19px",
                    color: "#5D5D5D",
                  }}
                  className="mb-1 mb-md-3"
                >
                  Get 10% off your first order and be the first to know when we
                  launch exclusive discounts and free delivery offers.
                </h5>
              </div>
              <Form onSubmit={handleSubmit} className="w-100">
                <Row>
                  <Col xs={12} md={12}>
                    <Form.Group className="mb-2">
                      <Form.Control
                        type="text"
                        name="firstName"
                        id="firstName"
                        placeholder="Please enter your firstName"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                      />
                      {error.firstName && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {error.firstName}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={12}>
                    <Form.Group className="mb-2">
                      {/* <Form.Label>Email address</Form.Label> */}
                      <Form.Control
                        type="email"
                        firstName="email"
                        id="email"
                        placeholder="Please enter an email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                      {error.email && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {error.email}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  {/* <Col xs={12}><Form.Group className='w-100'>
                 
                  <PhoneInput
      defaultCountry="NG"
      value={phoneNumber}
      onChange={setPhoneNumber}
      international
      countryCallingCodeEditable={false} 
    />

                  {error.phoneNumber && <div className="text-danger" style={{ fontSize: "12px" }}>{error.phoneNumber}</div>}
                </Form.Group></Col> */}
                </Row>

                <div className="mt-4 mb-3">
                  <Button
                    type="submit"
                    className="btn-primary w-100"
                    disabled={loading}
                  >
                    {loading ? "Joining..." : "Join our community"}
                  </Button>
                </div>
              </Form>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VirtuePlusModal;
